import { render, staticRenderFns } from "./BeatPhenomenonViz.vue?vue&type=template&id=796104f2&scoped=true"
import script from "./BeatPhenomenonViz.vue?vue&type=script&lang=js"
export * from "./BeatPhenomenonViz.vue?vue&type=script&lang=js"
import style0 from "./BeatPhenomenonViz.vue?vue&type=style&index=0&id=796104f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796104f2",
  null
  
)

export default component.exports